// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-spacing[data-v-2a72a510]{margin-top:-1.5rem;margin-bottom:0}.btn-ok[data-v-2a72a510]{background-color:#00afef!important}", ""]);
// Exports
module.exports = exports;
